export const doTestimonialClicks = () => {
    let testimonials = document.querySelectorAll('.damd-testimonials');
    for(let testimonailmod of testimonials){
      let controls = testimonailmod.querySelectorAll('.review-control');
      for(let control of controls) control.addEventListener('click', (e) => {testimonialClick(e)} );
    }
  }
export const testimonialClick = (e) => {
    let control = e.target.classList.contains('.review-control') ? e.target : e.target.closest('.review-control');
    if(!control) return;
    let parent = control.closest('.reviewswrap');
    let reviews = parent ? parent.querySelectorAll('.review') : false;
    let controls = parent ? parent.querySelectorAll('.review-control') : false;
    if(!reviews || !controls ) return;

    let target = control.dataset.reviewTarget;
    for(let ctrl of controls){
        if(ctrl === control){
            ctrl.classList.add('active');
        } else {
            ctrl.classList.remove('active');
        }
    }
    for(let review of reviews){
        if(review.id === target){
            review.classList.add('active');
        } else {
            review.classList.remove('active');
        }
    }
}